import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { environment } from '../../../environments/environment.development';
import { statusCodes } from '../../shared/constants/statusCodes';
import Swal from 'sweetalert2';
import { permissionURL } from '../../shared/constants/commonConstants';


interface Permission {
  allow: string[];
  deny: string[];
}


@Injectable({
  providedIn: 'root'
})
export class AbacService {
  abacValue: Permission = { allow: [], deny: [] }
  BASE_API_URL = environment.BASE_API_URL;

  constructor(private readonly commonService: CommonService) { }

  setAccessControl(): void {
    const url = this.BASE_API_URL + permissionURL.abacURL
    const obj = {
      'object_id': 456,
      'object_type': 'webpage',
      'role_id': 1
    }
    this.commonService.post(url, obj).subscribe({
      next: (response) => {
        if (response.code === statusCodes.SUCCESS) {
          this.abacValue = response.data[0].allowed_actions
        }
        else {
          this.handleError(response)
        }
      },
      error: (e) => {
        this.handleError(e.error)
      }
    })
  }

  clearAccessControl(): void {
    this.abacValue = { allow: [], deny: [] }
  }

  verifyAccess(value: string): boolean {
    return this.abacValue?.allow?.includes(value) || false;
  }

  handleError(error: any): void {
    const errorCodes = [
      statusCodes.INTERNAL_SERVER_ERROR,
      statusCodes.NOT_FOUND,
      statusCodes.UNAUTHORIZED,
      statusCodes.UNPROCESSABLE_ENTITY,
      statusCodes.BAD_REQUEST,
      statusCodes.CONFLICT
    ];
    if (errorCodes.includes(error.code)) {
      Swal.fire({
        text: error.message,
        icon: 'error'
      });
    }
  }

}
